var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#321D47;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E6007A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637.3,319.3c0,175.2-142,317.3-317.3,317.3S2.7,494.6,2.7,319.3S144.8,2.1,320,2.1S637.3,144.1,637.3,319.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M444.2,392.4h-67.6l-12.7-31h-85.8l-12.7,31h-67.6l80.9-184.3h84.5L444.2,392.4z M321.1,256l-22.4,55h44.7 L321.1,256z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 321,
    cy: 122.1,
    r: 46.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 321,
    cy: 517.1,
    r: 46.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 147.8,
    cy: 216,
    r: 46.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 494.3,
    cy: 216,
    r: 46.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 147.8,
    cy: 424.8,
    r: 46.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 494.3,
    cy: 424.8,
    r: 46.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetHub);
export default __webpack_public_path__ + "static/media/asset-hub.e8cce471ee627d3748bd80bfb4c55632.svg";
export { ForwardRef as ReactComponent };